var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingLabelVip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 26,
    viewBox: "0 0 43 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=vip_02_vip, size=none",
    clipPath: "url(#clip0_4091_32154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000976562 13C0.000976562 5.8203 5.82127 0 13.001 0H30.001C37.1807 0 43.001 5.82029 43.001 13C43.001 20.1797 37.1807 26 30.001 26H13.001C5.82127 26 0.000976562 20.1797 0.000976562 13ZM13.001 2C6.92584 2 2.00098 6.92486 2.00098 13C2.00098 19.0751 6.92584 24 13.001 24H30.001C36.0761 24 41.001 19.0751 41.001 13C41.001 6.92487 36.0761 2 30.001 2H13.001Z",
    fill: "#EC2A38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8159 8.09945L15.2282 15.6554H15.3201L17.7372 8.09945H20.019L16.5963 18H13.952L10.5293 8.09945H12.8159ZM23.1887 8.09945V18H21.1341V8.09945H23.1887ZM24.8665 18V8.09945H28.7436C30.9964 8.09945 32.2871 9.48688 32.2871 11.4448C32.2871 13.4123 30.977 14.7756 28.7001 14.7756H26.9211V18H24.8665ZM26.9211 13.1174H28.3665C29.5848 13.1174 30.1745 12.4358 30.1745 11.4448C30.1745 10.4489 29.5848 9.7866 28.3617 9.7866H26.9211V13.1174Z",
    fill: "#EC2A38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_32154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 26,
    fill: "white",
    transform: "translate(0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingLabelVip);
export default __webpack_public_path__ + "static/media/rating_label_vip.2831ea7793df448fd7a1734cfdba64f3.svg";
export { ForwardRef as ReactComponent };